const zhCN = {
  emptyBtn: '清空',
  resetBtn: '重置',
  saveAsBtn: '另存为',
  saveBtn: '保存',
  comfirmBtn: '确定',
  cancelBtn: '取消',
  editBtn: '编辑',
  deleteBtn: '删除',
  addBtn: '新增时间配置',
  searchBtn: '搜索',
  authBtn: '设置授权',
  setBtn: '设置时间',

  searchTxt: '请输入时间配置名称',

  tableName: '时间配置名称',
  tableState: '状态',
  tableOpera: '操作',
  
  tableSetDetail: '时间配置详情',
  tableWeek: '星期',
  tableWeekTime: '星期/时间',
  monday: '星期一',
  tuesday: '星期二',
  wednesday: '星期三',
  thursday: '星期四',
  friday: '星期五',
  saturday: '星期六',
  sunday: '星期天',
  tableSetted: '已配置时间段',
  tableAuthedDevice: '已授权设备',
  tableDeviceName: '设备名称',
  tableDeviceBelong: '所属组织',
  tableOpen: '启用',
  tableDisabled: '禁用',

  deleteTipTitle: '您确定要删除该时间配置？',
  deleteTipContent: '删除后，该时间配置的所有授权将被取消！',

  addTitle: '新增时间配置',
  addConfigName: '时间配置名称',
  addConfigNameTxt: '请输入时间配置名称',
  configNameBlank: '时间配置名称不能为空！',
  configNameWarning: '时间配置名称最多 20 个字！',

  nameChanging: '修改时间配置名称中...',
  stateChanging: '修改时间配置启用状态中...',
  deletingConfig: '删除时间配置中...',

  authDeviceTitle: '授权门禁设备',
  authDevicesSuccess: '授权门禁设备成功！',

  setTimeTitle: '配置时间段',
  deleteTimeRangeWarning: '确定要删除当前时间段？',

  pickerFromTimeTxt: '选择起始时间',
  pickerFromTimeBlank: '起始时间不能为空！',
  pickerToTimeTxt: '选择截止时间',
  pickerToTimeTxtBlank: '截止时间不能为空！',
  timeRangeErr: '起始时间应小于截止时间！',
  timeRangeTiny: '起始时间与截止时间至少间 10 分钟！',

  saveAsNameTxt: '请输入另存为的时间配置名称',
  saveAsNameBlank: '另存为的时间配置名称不能为空！',
  saveAsNameWarning: '另存为的时间配置名称最多 20 个字！',
  nameValidating: '重名校验',
  nameRepeatWarning: '配置名称重复，点击 "另存为" 将覆盖该配置！',

  saveAsSuccess: '另存为时间配置成功！',
  saveSuccess: '保存时间配置成功！'
}

const enUS = {
  emptyBtn: 'Empty',
  resetBtn: 'Reset',
  saveAsBtn: 'Save As',
  saveBtn: 'Save',
  comfirmBtn: 'Comfirm',
  cancelBtn: 'Cancel',
  editBtn: 'Edit',
  deleteBtn: 'Delete',
  addBtn: 'Add',
  searchBtn: 'Search',
  authBtn: 'Set Auth',
  setBtn: 'Set Time',

  searchTxt: 'Please enter the name of time configuration',

  tableName: 'Time Configuration',
  tableState: 'Status',
  tableOpera: 'Operation',

  tableSetDetail: 'Details of configuration',
  tableWeek: 'Week',
  tableWeekTime: 'Week/Time',
  monday: 'Mon.',
  tuesday: 'Tues.',
  wednesday: 'Wed.',
  thursday: 'Thurs.',
  friday: 'Fri.',
  saturday: 'Sat.',
  sunday: 'Sun.',
  tableSetted: 'Time Period',

  tableAuthedDevice: 'Authorized Device',
  tableDeviceName: 'Device\'s Name',
  tableDeviceBelong: 'Organization',
  tableOpen: 'Open',
  tableDisabled: 'Disabled',

  deleteTipTitle: 'Are you sure you want to delete this time configuration?',
  deleteTipContent: 'After deletion, all authorization for this configuration will be cancelled!',

  addTitle: 'Add Time Configuration',
  addConfigName: 'Config Name',
  addConfigNameTxt: 'Please enter the name of time configuration',
  configNameBlank: 'The name of time configuration cannot be empty!',
  configNameWarning: 'The name of time configuration up to 20 characters!',
  
  nameChanging: 'Changing the time configuration name...',
  stateChanging: 'Changing the time configuration state...',
  deletingConfig: 'Deleting time configuration...',

  authDeviceTitle: 'Authorize devices',
  authDevicesSuccess: 'The authorize equipment is successful!',

  setTimeTitle: 'Time period setting',
  deleteTimeRangeWarning: 'Are you sure to delete this time setting?',

  pickerFromTimeTxt: 'Select start time',
  pickerFromTimeBlank: 'The start time cannot be empty!',
  pickerToTimeTxt: 'Selection end time',
  pickerToTimeTxtBlank: 'The end time cannot be empty!',
  timeRangeErr: 'The start time should be less than the end time!',
  timeRangeTiny: 'At least 10 minutes between start time and end time!',

  saveAsNameTxt: 'Please enter a time configuration name to save as',
  saveAsNameBlank: 'The save as time configuration name cannot be empty!',
  saveAsNameWarning: 'Save as time configuration name up to 20 words!',
  nameValidating: 'Name Checking',
  nameRepeatWarning: 'Duplicate configuration name, click "Save As" will overwrite that configuration!',

  saveAsSuccess: 'Save as time configuration successful!',
  saveSuccess: 'Save time configuration successful!'
}

export default { zhCN, enUS }